import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDisableCountryDropdown]',
  standalone: false
})
export class DisableCountryDropdownDirective {

  constructor(private el: ElementRef) { }
  @HostListener('click', ['$event'])
  onClick(event: Event) {
    event.stopPropagation();
    const flagContainer = this.el.nativeElement.querySelector('.iti__flag-container');
    const dropDown = this.el.nativeElement.querySelector('.dropdown-menu');
    if (flagContainer) {
      flagContainer.style.pointerEvents = 'none';
    }

    if(dropDown){
      dropDown.style.display = 'none';
    }
  }
}
